import { ReactComponentManifest } from "web/entrypoints/common/setup";
import { FeatureArticle } from "web/react/pages/feature-article";
import withRedux from "web/react/redux-provider";

export const featureArticleComponents: ReactComponentManifest = {
    FeatureArticle: withRedux(FeatureArticle),
};
